import * as req from 'api/actions';

export const setModal = (data = {}) => ({
  type: 'SET_MODAL',
  data,
});

export const startLoading = (x, z = 'loader') => ({
  ...x,
  loading: x.loading.concat([z]),
});

export const endLoading = (x, z = 'loader') => ({
  ...x,
  loading: x.loading.filter(y => y !== z),
});

export const getCms = () => req.list(
  'CMS',
  '/api/v1/taxpayers/cms', // site api ep
);
